export interface TimerService {
  setTimeout(fn: () => void, ms: number): number;
  setInterval(fn: () => void, ms: number): number;
  clearTimeout(id: number): void;
  clearInterval(id: number): void;
}

export class BrowserTimerService implements TimerService {
  setTimeout(
    fn: () => void,
    ms: number
  ): number {
    return window.setTimeout(fn, ms);
  }

  setInterval(
    fn: () => void,
    ms: number
  ): number {
    return window.setInterval(fn, ms);
  }

  clearTimeout(id: number): void {
    window.clearTimeout(id);
  }

  clearInterval(id: number): void {
    window.clearInterval(id);
  }
}
